module.exports = __webpack_public_path__ + "static/media/dydx.227d60f5.svg";